import dayjs from 'dayjs';

/**
 * Renders a study note's creation time for the comment list. Formats the ISO timestamp as MM/DD/YYYY, HH:mm:ss followed by the UTC offset.
 *
 * @param createdAt - ISO creation timestamp of the comment.
 * @returns Formatted date-time string including the offset.
 */
export const formatTimestamp = (createdAt: string) =>
  dayjs(createdAt).format('MM/DD/YYYY, HH:mm:ss Z');
